export function redirectUser(user, navigate) {
    localStorage.setItem("user", JSON.stringify(user.data));
    return navigate("/dashboard")
};